import { sendRequest } from 'api/sendRequest';
import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';

import { endpoints } from 'constants/endpoints';

export const getOneOnOneRatingApi = ({ masterId, instanceId }: OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.rating(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      instanceId,
    },
  });
};

export const updateOneOnOneRatingApi = ({ masterId, instanceId, rating }: { rating: number } & OneOnOneRequestI) => {
  const url = endpoints.oneOnOneRevamped.rating(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      instanceId,
      rating,
    },
  });
};
